var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-full md:1/2 lg:w-1/2 xl:w-1/3 mb-base"},[_c('PipelineCards')],1),_c('div',{staticClass:"vx-col w-full sm:w-full md:1/2 lg:w-1/2 xl:w-1/3 mb-base"},[_c('TodaysAdviceAppointments')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }